<svelte:options customElement="hb-contact-item" />

<script lang="ts">
  /**
   * Svelte Contact Item WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    phone = undefined,
    address = undefined,
    email = undefined,
    site = undefined,
    social = undefined,
    config = { icon: { fill: false }, dispatcher: true, text: true },
  }: Component = $props();

  let action: string;
  let payload:
    | Component["phone"]
    | Component["address"]
    | Component["email"]
    | Component["site"]
    | Component["social"] = $state(undefined);
  let windowUri: string | undefined = $state(undefined);
  let openWindow = $state(false);

  $effect(() => {
    if (typeof config === "string") {
      try {
        config = JSON.parse(config as unknown as string);
      } catch (err) {}
    }

    if (!config.icon) config.icon = { fill: false };
    if (config.text !== false) config.text = true;
    if (config.dispatcher !== false) config.dispatcher = true;

    if (phone) {
      action = "phone";
      payload = phone;

      try {
        phone = JSON.parse(phone as unknown as string);
      } catch (err) {}
    } else if (social) {
      action = "social";
      payload = social;

      try {
        social = JSON.parse(social as unknown as string);
      } catch (err) {}
      if (social?.pageUri) {
        openWindow = true;
        windowUri = social.pageUri;
      }
    } else if (address) {
      action = "address";
      payload = address;

      try {
        address = JSON.parse(address as unknown as string);
      } catch (err) {}
      if (address?.mapUri || address?.latLang) {
        openWindow = true;
        if (address.latLang)
          windowUri = `https://maps.google.com?lat=${address.latLang[0]}&lng=${address.latLang[1]}`;
        if (address.mapUri) windowUri = address.mapUri;
      }
    } else if (email) {
      action = "email";
      payload = email;
      try {
        email = JSON.parse(email as unknown as string);
      } catch (err) {}
      if (email?.mailLink) {
        openWindow = true;
        windowUri = email.address;
      }
    } else if (site) {
      action = "site";
      payload = site;
      try {
        site = JSON.parse(site as unknown as string);
      } catch (err) {}
      if (site?.open && site?.uri) {
        openWindow = true;
        windowUri = site.uri;
      }
    }
  });
  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function dispatchClick() {
    const name = "contactClick";
    const detail = { action, options: payload };
    dispatch(name, detail);
  }
  function handleClick() {
    if (openWindow && windowUri) {
      window.open(windowUri);
    } else if (config.dispatcher) {
      dispatchClick();
    }
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<span
  style={openWindow && windowUri ? "cursor:pointer;" : ""}
  onclick={() => handleClick()}
>
  {#if address}
    <span class="iconcell" part="iconcell"
      >{#if config.icon}
        <i class="bi bi-geo-alt" />
      {/if}</span
    >
    {#if config.text}<span class="prop" part="prop" property="address"
        >{address.address}</span
      >{/if}
  {:else if phone}
    <span class="iconcell" part="iconcell"
      >{#if config.icon}
        <i class="bi bi-telephone" />
      {/if}</span
    >

    {#if config.text}<span class="prop" part="prop" property="telephone"
        >{phone.number}</span
      >{/if}
  {:else if email}
    <span class="iconcell" part="iconcell"
      >{#if config.icon}
        <i class="bi bi-envelope" />
      {/if}</span
    >

    {#if config.text}<span class="prop" part="prop" property="address"
        >{email.address}</span
      >{/if}
  {:else if site}
    <span class="iconcell" part="iconcell"
      >{#if config.icon}
        <i class="bi bi-globe" />
      {/if}</span
    >

    {#if config.text}<span class="prop" part="prop" property="address"
        >{site.label || site.uri}</span
      >{/if}
  {:else if social}
    <span class="iconcell" part="iconcell"
      >{#if config.icon}
        <i class="bi bi-{social.name}" />
      {/if}</span
    >

    {#if config.text}<span class="prop" part="prop" property="address"
        >{social.label}</span
      >{/if}
  {/if}
</span>

<style lang="scss">
  // @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
